export default __webpack_public_path__ + "static/media/quizzical-list.85d648ff.jpg";